import React from "react";
import { Link } from "react-router-dom";
import { INITIATIVES } from "@/lib/initiatives";
import { ArrowRight } from "lucide-react";

export default function InitiativesList() {
  return (
    <section className="section-py">
      <div className="mx-auto max-w-7xl container-x">
        <div className="text-xs uppercase tracking-[0.24em] text-[#4A5568]">We Work For</div>
        <h1 className="mt-3 font-serif-display text-4xl md:text-6xl text-[#0A2540] max-w-3xl">
          Our seven initiatives.
        </h1>
        <p className="mt-4 text-[#4A5568] max-w-2xl">
          Each pillar is a long-term commitment — designed with communities, delivered
          in partnership, measured by real impact on Indian lives.
        </p>

        <div className="mt-14 grid md:grid-cols-2 gap-6 md:gap-8">
          {INITIATIVES.map((it) => {
            const Icon = it.icon;
            return (
              <Link
                to={`/initiatives/${it.slug}`}
                key={it.slug}
                data-testid={`initiative-list-${it.slug}`}
                className="group rounded-3xl overflow-hidden border border-[#0A2540]/10 bg-white flex flex-col hover:shadow-lg transition-shadow"
              >
                <div className="relative aspect-[16/9] overflow-hidden">
                  <img
                    src={it.image}
                    alt={it.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                  />
                  <div
                    className="absolute top-4 left-4 w-11 h-11 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: it.accent }}
                  >
                    <Icon className="w-5 h-5 text-white" strokeWidth={1.75} />
                  </div>
                </div>
                <div className="p-6 md:p-8">
                  <h3 className="font-serif-display text-2xl text-[#0A2540]">{it.title}</h3>
                  <p className="mt-3 text-[#4A5568] text-sm">{it.short}</p>
                  <div className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-[#0A2540]">
                    Read more <ArrowRight className="w-4 h-4" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
